import React from 'react'
import { useTranslation } from 'react-i18next'

import { useGetGroupsQuery, useGetViewerFollowingGroupsQuery } from '@/generated/graphql'

import { PriorityGroups } from './aside-group-priority.component'
import s from './aside.module.less'

export const AsidePrioritiesComponent = () => {
  const { t } = useTranslation()

  const { data: pinGroupData } = useGetViewerFollowingGroupsQuery({
    variables: {
      pagination: {
        last: 8,
      },
      filter: {
        isPinned: true,
        isOfficial: false,
      },
    },
  })

  const { data: groupData } = useGetViewerFollowingGroupsQuery({
    variables: {
      pagination: {
        last: 8,
      },
      filter: {
        isPinned: false,
        isOfficial: false,
      },
    },
  })

  const { data: officialGroupData } = useGetGroupsQuery({
    variables: {
      pagination: {
        last: 8,
      },
      filter: {
        isOfficial: true,
      },
    },
  })

  const pinGroups = pinGroupData
    ? pinGroupData.viewer.groups.edges
        .map(({ node }) => node)
        .slice()
        .reverse()
    : []

  const groups = groupData
    ? groupData.viewer.groups.edges
        .map(({ node }) => node)
        .slice()
        .reverse()
    : []

  const officialGroups = officialGroupData
    ? officialGroupData.groups.edges
        .map(({ node }) => node)
        .slice()
        .reverse()
    : []

  return (
    <div>
      <div className={s.subsubtitle}>{t('asideTitle.groups')}</div>
      <div className={s.menuItem}>
        <PriorityGroups groups={officialGroups} />
        <PriorityGroups groups={pinGroups} />
        <PriorityGroups groups={groups} />
      </div>
    </div>
  )
}
